<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">GRN</small>
      </legend>
      <div>
        <form @submit.prevent="newOil()">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>
                  GRN date
                  <span class="text-danger">*</span>
                </label>
                <input type="date" class="form-control grn_date input-rouded f-s-14" required />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Product</th>
                    <th scope="col text-right">qty</th>
                    <th scope="col">@qty</th>
                    <th scope="col text-right">Remark</th>
                    <th scope="col text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(invoice_product, k) in oilsitemsRows" :key="k">
                    <td scope="row">
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="deleteRow(k, invoice_product)"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                      <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, invoice_product)"></i> -->
                    </td>
                    <td>
                      <model-list-select
                        :list="systemProducts"
                        v-model="invoice_product.product_id"
                        option-value="id"
                        option-text="product_name"
                        placeholder="select Product"
                      ></model-list-select>
                    </td>
                    <td>
                      <input
                        class="form-control"
                        type="number"
                        min="0"
                        step=".01"
                        v-model="invoice_product.cartons_qty"
                        @change="calculateLineTotal(invoice_product)"
                      />
                    </td>
                    <td>
                      <input
                        class="form-control"
                        type="number"
                        min="0"
                        step=".01"
                        v-model="invoice_product.cartons_litres"
                        @change="calculateLineTotal(invoice_product)"
                      />
                    </td>

                    <td>
                      <input class="form-control" type="text" v-model="invoice_product.remarks" />
                    </td>
                    <td>
                      <input
                        readonly
                        class="form-control text-right"
                        type="number"
                        min="0"
                        step=".01"
                        v-model="invoice_product.total_qty"
                      />
                    </td>
                  </tr>
                  <tr v-show="oilsitemsRows.length === 0">
                    <td colspan="5">
                      <p class="text-center alert-danger p-2">No products added/available.</p>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5" class="text-right">Sub Total</td>
                    <input
                      readonly
                      class="form-control text-right sub_total"
                      type="number"
                      min="0"
                      step=".01"
                      :value="invoice_subtotal"
                    />
                  </tr>
                  <tr>
                    <td colspan="5" class="text-right">Total</td>
                    <input
                      readonly
                      class="form-control text-right grn_grand_total"
                      type="number"
                      min="0"
                      step=".01"
                      :value="invoice_total"
                    />
                  </tr>
                </tfoot>
              </table>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 mb-2">
              <button type="button" class="btn btn-info" @click="addOilsItems">
                <i class="fa fa-plus-circle"></i>
                Add
              </button>
            </div>
            <button type="submit" class="btn btn-primary btn-flat creatingOilreceiving btn-rounded">
              <i class="fa fa-plus"></i> receive goods
            </button>
            <button
              type="button"
              class="btn-rounded btn-flat creatingOilreceivingLoader btn-rounded"
            >
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
            </button>
          </div>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import $ from "jquery";
import router from "../router/index";
import { ModelListSelect } from "vue-search-select";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0
    };
  },
  created() {
    this.loadProduct();
  },
  computed: {
    ...mapGetters(["systemProducts", "oilsitemsRows"])
  },

  methods: {
      ...mapActions(["newOil", "loadProduct"]),
      ...mapMutations(["addOilsItems"]),

       calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.oilsitemsRows.reduce(function(sum, product) {
        var lineTotal = parseFloat(product.total_qty);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(invoice_product) {
      var total =
        parseFloat(invoice_product.cartons_qty) *
        parseFloat(invoice_product.cartons_litres);
      if (!isNaN(total)) {
        invoice_product.total_qty = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, invoice_product) {
      var idx = this.oilsitemsRows.indexOf(invoice_product);
      console.log(idx, index);
      if (idx > -1) {
        this.oilsitemsRows.splice(idx, 1);
      }
      this.calculateTotal();
    }
  },
  components: {
    ModelListSelect
  }

};
</script>
<style scoped>
.creatingOilreceivingLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/oils/oil.vue